












































import Vue from "vue";
import BaseButton from "@/components/BaseButton";
import PageTitle from "@/components/PageTitle";
import PromoteViewItem from "../PromoteViewItem.vue";

export default Vue.extend({
  name: "PromoteView",
  components: { PromoteViewItem, BaseButton, PageTitle },
});
